import { useCallback, useState } from 'react';
import { noop } from 'lodash';
import { useAppDispatch } from '../../../store/hooks';
import { BulkEditLocationRequest, BulkEditLocationResponse } from '../types';
import { updateStockBulkLocation } from '../../../store/thunks/stock/stock-part-requests/stockBulkOperationsThunks';
import { ResponseSingleResult } from '../../../core/types/coreTypes';

type SuccessFn = (response: BulkEditLocationResponse) => void;
type UpdateFn = (input: BulkEditLocationRequest) => void;

export const useEditLocation = (onSuccess: SuccessFn = noop): [boolean, UpdateFn] => {
  const [pending, setIsPending] = useState<boolean>(false);
  const dispatch = useAppDispatch();

  const update: UpdateFn = useCallback(async (input) => {
    setIsPending(true);
    const data = await dispatch(updateStockBulkLocation(input));
    const response = data.payload as ResponseSingleResult<BulkEditLocationResponse>;
    if (response.success) {
      onSuccess(response.data);
    }
    setIsPending(false);
  }, [dispatch, onSuccess]);

  return [pending, update];
};
